module.exports = __webpack_public_path__ + "static/media/FSemilla.c21b21eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Achievements/FSemilla.png
// module id = 354
// module chunks = 0